import {DatePipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ConfirmationService, MenuItem} from 'primeng/api';
import {ToastService} from '../../../../services/toast.service';
import {Instancia} from '../../../../types/Instancia.type';
import {NotaFiscal} from '../../../../types/notafiscal.type';
import { NotafiscalService } from './notafiscal.service';
import { IntegradorService } from '../../../../services/integrador.service';
import { ProcessoNotaFiscal } from '../../../../types/ProcessoNotaFiscal.type';


interface Filtro {
  id: string;
  nome: string;
}

@Component({
  selector: 'app-notafiscals',
  templateUrl: './notafiscals.component.html',
  styleUrl: './notafiscals.component.css',
  providers: [DatePipe, ConfirmationService],
})
export class NotaFiscalsComponent implements OnInit {
  itensReversao: MenuItem[];

  notaFiscals!: NotaFiscal[];
  notasSelecionadas: NotaFiscal[] = [];

  loading: boolean = false;
  loadingInteg: boolean = false;
  loadingSincronizar: boolean = false;
  dateInicio: Date | undefined;
  dateFim: Date | undefined;
  rangeDates!: string;
  instancias: Instancia[] = [];
  instanciaSelecionada!: string;

  processosSelecionados: ProcessoNotaFiscal[] = [];
  processos: ProcessoNotaFiscal[] = [];

  // processos: Instancia[] = [
  //   {id: 'MENSAL', nome: 'MENSAL'},
  //   {id: 'MENSAL_REVENDA', nome: 'MENSAL REVENDA'},
  //   {id: 'REVENDA_COMPLEMENTAR', nome: 'REVENDA COMPLEMENTAR'},
  //   {id: 'MENSAL_COMPLEMENTAR', nome: 'MENSAL COMPLEMENTAR'},
  // ];

  status: any[] = [ {name: 'Integrado', value: 'SUCESSO' }
    , {name: 'Erro', value: 'ERRO'}
    , {name: 'Cancelado', value: 'CANCELADO'}
    , {name: 'Estornado', value: 'ESTORNADO'}
    , {name: 'Aguardando Emissão', value: 'AGUARDANDO_EMISSAO'}
    , {name: 'Pendente Integração', value: 'PENDENTE_ENVIO'}
    , {name: 'Pendente Aprovação', value: 'PEND_APROVACAO'}
    , {name: 'Inconsistente', value: 'INCONSISTENTE'}
  ]

  statusTaxa: any[] = [ {name: 'Integrado', value: 'SUCESSO' }
    , {name: 'Erro', value: 'ERRO'}
    , {name: 'Cancelado', value: 'CANCELADO'}
    , {name: 'Estornado', value: 'ESTORNADO'}
    , {name: 'Pendente Integração', value: 'PENDENTE_ENVIO'}
    , {name: 'Pendente Aprovação', value: 'PEND_APROVACAO'}
  ]

  fornecedores: Filtro[] = [];
  fazendas: Filtro[] = [];
  taxas: Filtro[] = [];

  constructor(
    private notaFiscalService: NotafiscalService,
    private toastService: ToastService,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService
  ) {
    this.itensReversao = [
      {
        label: 'Nota Fiscal',
        items: [
          {
            label: 'Cancelar',
            icon: 'pi pi-times',
            command: () => {
              this.cancelar();
            },
          },
          {
            label: 'Estornar no PIMS',
            icon: 'pi pi-undo',
            command: () => {
              this.estornar();
            },
          },
          {
            label: 'Cancelar e Estornar',
            icon: 'pi pi-times-circle',
            command: () => {
              this.cancelarEstornar();
            },
          },
        ]
      },{
        label: 'Taxas',
        items: [
          {
            label: 'Cancelar',
            icon: 'pi pi-times',
            command: () => {
              this.cancelarTaxa();
            },
          },
        ]
      },

    ];
  }

  ngOnInit() {

    this.getProcessos();
  }

  getProcessos() {
    this.loading = true;

    this.notaFiscalService.getProcessos().subscribe({
      next: (data) => {
        this.processos = data;
      }, 
      error: (error) => {
        this.toastService.erro(
          error.error.title,
          'Erro ao buscar os processos: ' + error.error.detail
        );
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    })
  }

  getNotaFiscals() {
    this.loading = true;

    this.notasSelecionadas = [];

    if (
      this.instanciaSelecionada != undefined &&
      this.rangeDates != undefined 
      && this.processosSelecionados.length > 0
    ) {
      let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
      let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

      let processos = this.processosSelecionados.map(p => p.codigo).join(',')

      this.notaFiscalService
        .getNotaFiscals(this.instanciaSelecionada, dataInicial, dataFinal, processos)
        .subscribe({
          next: (data) => {
            this.notaFiscals = data;

            const cdFornecs = [...new Set(this.notaFiscals.map(nf => nf.cdFornecErp))];
            this.fornecedores = cdFornecs.map(fornec => ({id: fornec, nome: fornec}))

            const cdFazendas = [...new Set(this.notaFiscals.map(nf => nf.fazenda))];
            this.fazendas = cdFazendas.map(fazenda => ({id: fazenda, nome: fazenda}))

            const cdTaxas = [...new Set(this.notaFiscals.map(nf => nf.descTaxa))];
            this.taxas = cdTaxas.map(taxa => ({id: taxa, nome: taxa}))

          },
          error: (error) => {
            this.toastService.erro(
              error.error.title,
              'Erro ao buscar: ' + error.error.detail
            );
          },
          complete: () => {
            this.loading = false;
          },
        });
    } else {
      this.toastService.alerta('Filtros', 'Informe os filtros necessários');
      this.loading = false;
    }
  }

  sincronizar() {
    this.notasSelecionadas = [];

    if (this.instanciaSelecionada == undefined) {
      this.toastService.alerta('Instância', 'Selecione uma instância');

      return;
    }

    if (this.rangeDates == undefined) {
      this.toastService.alerta('Período', 'Selecione o período');

      return;
    }

    if( this.processosSelecionados.length == 0) {
      this.toastService.alerta('Processo', 'Selecione um processo');

      return;
    }

    this.loadingSincronizar = true;
    this.loading = true;

    let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
    let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

    let processos = this.processosSelecionados.map(p => p.codigo).join(',');

    this.notaFiscalService
      .postSolicitaNotaFiscal(this.instanciaSelecionada, dataInicial, dataFinal, processos)
      .subscribe({
        next: (value) => {
          this.toastService.sucesso('Sucesso', 'Busca realizada');
        },
        error: (err) => {
          this.toastService.erro(
            'Erro',
            'Erro na solicitação: ' + err.error.message
          );
          this.loadingSincronizar = false;
          this.loading = false;
        },
        complete: () => {
          this.loadingSincronizar = false;
          this.loading = false;
          this.getNotaFiscals();
        },
      });
  }

  integrar() {
    if (this.instanciaSelecionada == undefined) {
      this.toastService.alerta('Instância', 'Selecione uma instância');

      return;
    }

    if (this.rangeDates == undefined) {
      this.toastService.alerta('Período', 'Selecione o período');

      return;
    }

    if (
      this.notasSelecionadas.filter(
        (nf) => nf.fgStatusInteg == 'ESTORNADO' || nf.fgStatusInteg == 'INCONSISTENTE'
      ).length > 0
    ) {
      this.toastService.alerta(
        'Estornada',
        'Existem notas selecionadas que não podem ser integradas, favor verificar.'
      );

      return;
    }


    if (
      this.notasSelecionadas.filter(
        (nf) => nf.fgStatusInteg == 'SUCESSO' || nf.fgStatusInteg == 'AGUARDANDO_EMISSAO'
      ).length > 0
    ) {
      this.toastService.alerta(
        'Integrada',
        'Existem notas selecionadas que já foram integradas, favor verificar'
      );

      return;
    }

    this.loadingInteg = true;

    let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
    let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

    console.log(this.notasSelecionadas);

    let ids = this.notasSelecionadas.map((m) => m.idNf);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    this.notaFiscalService.getIntegraNotaFiscal(ids).subscribe({
      next: (value) => {
        this.toastService.sucesso('Sucesso', 'Integração realizada');
      },
      error: (err) => {
        this.toastService.erro(
          'Erro',
          'Erro na solicitação: ' + err.error.message
        );
        this.notasSelecionadas = [];
        this.loadingInteg = false;
      },
      complete: () => {
        this.loadingInteg = false;
        this.getNotaFiscals();
        this.notasSelecionadas = [];
      },
    });
  }

  integrarTaxa() {
    if (this.instanciaSelecionada == undefined) {
      this.toastService.alerta('Instância', 'Selecione uma instância');

      return;
    }

    if (this.rangeDates == undefined) {
      this.toastService.alerta('Período', 'Selecione o período');

      return;
    }

    if (
      this.notasSelecionadas.filter((nf) => nf.statusIntegTaxa == 'SUCESSO').length >
      0
    ) {
      this.toastService.alerta(
        'Integrada',
        'Existem notas selecionadas que já foram integradas, favor verificar'
      );

      return;
    }

    this.loadingInteg = true;

    let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
    let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

    let ids = this.notasSelecionadas.map((m) => m.idNf);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    this.notaFiscalService.postIntegraNotaFiscalTaxa(ids).subscribe({
      next: (value) => {
        this.toastService.sucesso('Sucesso', 'Integração das taxas realizada');
      },
      error: (err) => {

        console.log(err)

        this.toastService.erro(
          'Erro',
          'Erro na solicitação: ' + err.error
        );
        this.loadingInteg = false;
      },
      complete: () => {
        this.loadingInteg = false;
        //this.getNotaFiscals();
      },
    });
  }

  getDataPipeTransForm(data: string): string | null {
    return this.datePipe.transform(data, 'yyyy-MM-dd');
  }

  exportar() {
    if (this.instanciaSelecionada == undefined) {
      this.toastService.alerta('Instância', 'Selecione uma instância');

      return;
    }

    if (this.rangeDates == undefined) {
      this.toastService.alerta('Período', 'Selecione o período');

      return;
    }

    if (this.notasSelecionadas.length > 0) {
      this.loadingInteg = true;

      let ids = this.notasSelecionadas.map((m) => m.idNf);

      let corpo = {
        ids: ids,
        usuario: localStorage.getItem('cdUsuarioErp'),
      };

      this.notaFiscalService.exportarNotaFiscal(ids).subscribe({
        next: (value) => {
          const url = window.URL.createObjectURL(value);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'data.xlsx';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        },
        error: (error) => {
          this.toastService.erro('Exportar', 'Erro ao exportar:' + error.error);
          this.loadingInteg = false;
        },
        complete: () => {
          this.loadingInteg = false;
        },
      });
    } else {
      this.toastService.info(
        'Exportar',
        'Necessário selecionar os registros que devem ser exportados'
      );
    }
  }

  cancelar() {
    if (
      this.notasSelecionadas.filter((nf) => nf.fgStatusInteg != 'SUCESSO' && nf.fgStatusInteg != 'AGUARDANDO_EMISSAO' && nf.fgStatusInteg != 'ERRO' && nf.fgStatusInteg != 'PENDENTE_ENVIO' && nf.fgStatusInteg != 'INCONSISTENTE').length >
      0 ||
      this.notasSelecionadas.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros integrados');

      return;
    }

    if (
      this.notasSelecionadas.filter((nf) => nf.statusIntegTaxa == 'SUCESSO').length > 0
    ) {
      console.log("NF Integrada");

      this.confirmaTaxaIntegrada().then(() => {
        this.confirmaCancelamento();
      })

    } else {
      this.confirmaCancelamento()
    }

  }

  private confirmaTaxaIntegrada(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.confirmationService.confirm({
        message: 'Existem taxas integradas das notas selecionadas, você deseja continuar?',
        header: 'Confirmar',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'none',
        acceptButtonStyleClass: 'bg-red-500',
        rejectIcon: 'none',
        rejectButtonStyleClass: 'p-button-text',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: () => {
          resolve();
        },
        reject: () => {
          reject();
        }
      });
    });
  }

  confirmaCancelamento() {

    let ids = this.notasSelecionadas.map((m) => m.idNf);

    let corpo = {
      ids: ids,
      justificativa: ''
    };

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar os itens selecionados?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.notaFiscalService.postCancelarNF(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Solcitação realizada');
          },
          error: (err) => {
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error.message
            );
            this.loadingInteg = false;
          },
          complete: () => {
            this.loadingInteg = false;
            this.getNotaFiscals();
            this.notasSelecionadas = [];
          },
        });
      },
    });
  }

  estornar() {
    if (
      this.notasSelecionadas.filter((nf) => nf.fgStatusInteg != 'CANCELADO').length >
      0 ||
      this.notasSelecionadas.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros cancelados');

      return;
    }

    // this.loadingInteg = true;

    let ids = this.notasSelecionadas.map((m) => m.idNf);

    let corpo = {
      ids: ids,
      justificativa: ''
    };

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja estornar os itens selecionados no PIMS? Essa operação é irreversível',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.notaFiscalService.postEstornarNF(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Solicitação realizada');
          },
          error: (err) => {
            console.error(err)
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error
            );
            this.loadingInteg = false;
          },
          complete: () => {
            this.loadingInteg = false;
            this.getNotaFiscals();
            this.notasSelecionadas = [];
          },
        });
      },
    });
  }

  cancelarTaxa() {
    if (
      this.notasSelecionadas.filter((nf) => nf.statusIntegTaxa != 'SUCESSO' && nf.statusIntegTaxa != 'CANCELADO' && nf.statusIntegTaxa != 'PENDENTE_ENVIO').length >
      0 ||
      this.notasSelecionadas.length == 0
    ) {
      this.toastService.alerta('', 'Status atual não possibilita o cancelamento, favor verificar.');

      return;
    }

    if (
      this.notasSelecionadas.filter((nf) => nf.statusIntegTaxa == 'SUCESSO').length > 0
    ) {

      this.confirmationService.confirm({
        message: 'Existem taxas selecionadas que já estâo integradas, você deseja continuar o cancelamento?',
        header: 'Confirmar',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'none',
        acceptButtonStyleClass: 'bg-red-500',
        rejectIcon: 'none',
        rejectButtonStyleClass: 'p-button-text',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: () => {

          setTimeout(() => {
            this.confirmaTaxaCancelamento();
          }, 1000);
        },
      });
    }else{

    this.confirmaTaxaCancelamento();
    }
  }

  confirmaTaxaCancelamento() {

    let taxas = this.notasSelecionadas.map((m) => ({idNf: m.idNf, taxa: m.descTaxa}) );

    let corpo = {
      taxas: taxas,
      justificativa: ''
    };

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar os itens selecionados? Essa operação é irreversível',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.notaFiscalService.postCancelarTaxa(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Solicitação realizada');
          },
          error: (err) => {
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error.message
            );
            this.loadingInteg = false;
          },
          complete: () => {
            this.loadingInteg = false;
            this.getNotaFiscals();
            this.notasSelecionadas = [];
          },
        });
      },
    });
  }

  cancelarEstornar() {
    if (
      this.notasSelecionadas.filter((nf) => nf.fgStatusInteg != 'SUCESSO' && nf.fgStatusInteg != 'AGUARDANDO_EMISSAO' && nf.fgStatusInteg != 'ERRO' && nf.fgStatusInteg != 'PENDENTE_ENVIO' && nf.fgStatusInteg != 'INCONSISTENTE').length >
      0 ||
      this.notasSelecionadas.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros integrados');

      return;
    }

    if (
      this.notasSelecionadas.filter((nf) => nf.statusIntegTaxa == 'SUCESSO').length > 0
    ) {
      console.log("NF Integrada");

      this.confirmaTaxaIntegrada().then(() => {
        this.confirmaCancelamentoEstorno();
      })

    } else {
      this.confirmaCancelamentoEstorno()
    }

  }

  confirmaCancelamentoEstorno() {

    let ids = this.notasSelecionadas.map((m) => m.idNf);

    let corpo = {
      ids: ids,
      justificativa: ''
    };

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar os itens selecionados?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.notaFiscalService.postCancelarEstornarNF(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Solcitação realizada');
          },
          error: (err) => {
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error.message
            );
            this.loadingInteg = false;
          },
          complete: () => {
            this.loadingInteg = false;
            this.getNotaFiscals();
            this.notasSelecionadas = [];
          },
        });
      },
    });
  }
}
